<template>
    <div>
        <van-cell @click="showPopup">展示弹出层</van-cell>
        <van-popup v-model="show">内容</van-popup>
    </div>

</template>
<script>
    import { Toast } from 'vant';
    export default {
        data() {
            return {
                active: 1,
                show:false
            }

        },
        methods: {
            onClickLeft() {
                this.$router.go(-1);//返回上一层
            },
            onClickRight() {
                Toast('按钮');
            },
            showPopup() {
                this.show = true
            }
        },
        watch:{

        }
    }
</script>
<style>
    .my-details-title div{
        display: inline-block;
    }
</style>